function odxMobileZoomDbg(payload) {
  try {
    if (typeof window.odxMobileZoomDebugLog === 'function') {
      window.odxMobileZoomDebugLog(Object.assign({ source: 'product-modal' }, payload));
    }
  } catch (_e) {}
}

if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      _unbindOdxTapToClose() {
        if (typeof this._odxTapCloseCleanup === 'function') {
          this._odxTapCloseCleanup();
          this._odxTapCloseCleanup = null;
        }
      }

      /** ODX variant mobile: double-tap on the dialog closes; thin X “close hint” on tap / long-press (CSS anim, no GSAP dep). */
      _bindOdxTapToClose() {
        this._unbindOdxTapToClose();
        const dialog = this.querySelector('.product-media-modal__dialog');
        if (!dialog) return;

        const modal = this;
        const openedAt = Date.now();
        const MOVE_MAX_PX = 18;
        const DURATION_MAX_MS = 550;
        const DOUBLE_TAP_MS = 420;
        const DOUBLE_TAP_MAX_DIST = 96;
        /* Close-hint timing: tap throttle 3.2s, long-press → hint 320ms, reduced-motion pulse 280ms (flashCloseHint) */
        const HINT_THROTTLE_MS = 3200;
        const LONGPRESS_MS = 320;
        const LONGPRESS_MOVE_MAX = 12;
        const captureOpts = { capture: true };
        let start = null;
        let maxDist = 0;
        /** @type {{ x: number, y: number, t: number } | null} */
        let lastTapEnd = null;
        let lastHintAt = 0;
        let longPressTimer = null;
        let longPressConsumed = false;

        const sinceOpen = () => Date.now() - openedAt;

        function clearLongPress() {
          if (longPressTimer != null) {
            clearTimeout(longPressTimer);
            longPressTimer = null;
          }
        }

        function ensureHintEl() {
          let hint = modal.querySelector('.odx-mobile-zoom-close-hint');
          if (!hint) {
            hint = document.createElement('div');
            hint.className = 'odx-mobile-zoom-close-hint';
            hint.setAttribute('aria-hidden', 'true');
            hint.innerHTML =
              '<span class="odx-mobile-zoom-close-hint__inner"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.15" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></span>';
            modal.appendChild(hint);
          } else if (!hint.querySelector('.odx-mobile-zoom-close-hint__inner')) {
            const svg = hint.querySelector('svg');
            if (svg) {
              const wrap = document.createElement('span');
              wrap.className = 'odx-mobile-zoom-close-hint__inner';
              hint.removeChild(svg);
              wrap.appendChild(svg);
              hint.appendChild(wrap);
            }
          }
          return hint;
        }

        function detachCloseHintAnimLoop(hint) {
          if (hint && hint._odxCloseHintAnimEnd) {
            hint.removeEventListener('animationend', hint._odxCloseHintAnimEnd);
            hint._odxCloseHintAnimEnd = null;
          }
        }

        function flashCloseHint(reason) {
          odxMobileZoomDbg({
            event: 'close-hint-flash',
            hintReason: reason || 'unspecified',
            modalState: 'open',
            sinceOpenMs: sinceOpen()
          });
          const hint = ensureHintEl();
          detachCloseHintAnimLoop(hint);
          hint.classList.remove('odx-mobile-zoom-close-hint--anim', 'odx-mobile-zoom-close-hint--reduced');
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            hint.classList.add('odx-mobile-zoom-close-hint--reduced');
            setTimeout(function () {
              hint.classList.remove('odx-mobile-zoom-close-hint--reduced');
            }, 280);
            return;
          }
          void hint.offsetWidth;
          hint.classList.add('odx-mobile-zoom-close-hint--anim');
          hint._odxCloseHintAnimEnd = function (ev) {
            if (ev.target !== hint) return;
            const nm = ev.animationName || '';
            if (nm.indexOf('odx-mobile-zoom-close-hint-flash') === -1) return;
            if (!start) {
              detachCloseHintAnimLoop(hint);
              return;
            }
            hint.classList.remove('odx-mobile-zoom-close-hint--anim');
            void hint.offsetWidth;
            hint.classList.add('odx-mobile-zoom-close-hint--anim');
          };
          hint.addEventListener('animationend', hint._odxCloseHintAnimEnd);
        }

        function maybeThrottleHint() {
          const now = Date.now();
          if (now - lastHintAt < HINT_THROTTLE_MS) return;
          lastHintAt = now;
          flashCloseHint('tap');
        }

        const onDown = (e) => {
          if (e.pointerType === 'mouse' && e.button !== 0) return;
          const now = Date.now();
          const x = e.clientX;
          const y = e.clientY;

          if (
            lastTapEnd &&
            now - lastTapEnd.t <= DOUBLE_TAP_MS &&
            Math.hypot(x - lastTapEnd.x, y - lastTapEnd.y) <= DOUBLE_TAP_MAX_DIST
          ) {
            e.preventDefault();
            odxMobileZoomDbg({
              event: 'modal-close-dbltap-2nd-down',
              modalState: 'closing',
              sinceOpenMs: sinceOpen(),
              gapMs: now - lastTapEnd.t,
              distPx: Math.round(Math.hypot(x - lastTapEnd.x, y - lastTapEnd.y)),
              ptrType: e.pointerType,
              pointerId: e.pointerId
            });
            lastTapEnd = null;
            start = null;
            maxDist = 0;
            clearLongPress();
            this.hide();
            return;
          }

          const pointerIdDown = e.pointerId;
          start = { x, y, t: now, id: pointerIdDown };
          maxDist = 0;
          longPressConsumed = false;
          clearLongPress();
          longPressTimer = setTimeout(function () {
            longPressTimer = null;
            if (!start || start.id !== pointerIdDown) return;
            if (maxDist > LONGPRESS_MOVE_MAX) return;
            longPressConsumed = true;
            flashCloseHint('longpress');
          }, LONGPRESS_MS);

          odxMobileZoomDbg({
            event: 'modal-pointerdown',
            modalState: 'open',
            sinceOpenMs: sinceOpen(),
            x: Math.round(x),
            y: Math.round(y),
            ptrType: e.pointerType,
            pointerId: e.pointerId
          });
        };

        const onMove = (e) => {
          if (!start || e.pointerId !== start.id) return;
          maxDist = Math.max(maxDist, Math.hypot(e.clientX - start.x, e.clientY - start.y));
          if (maxDist > LONGPRESS_MOVE_MAX) clearLongPress();
        };

        const onUp = (e) => {
          clearLongPress();
          if (!start || e.pointerId !== start.id) return;
          const upAt = Date.now();
          const dt = upAt - start.t;
          const tap = maxDist < MOVE_MAX_PX && dt < DURATION_MAX_MS;
          const x = e.clientX;
          const y = e.clientY;
          const moveSnapshot = maxDist;
          const wasLongPress = longPressConsumed;
          start = null;
          maxDist = 0;

          if (wasLongPress) {
            longPressConsumed = false;
            lastTapEnd = null;
            odxMobileZoomDbg({
              event: 'modal-longpress-up',
              modalState: 'open',
              sinceOpenMs: sinceOpen(),
              holdMs: dt,
              ptrType: e.pointerType
            });
            return;
          }

          if (!tap) {
            odxMobileZoomDbg({
              event: 'modal-pointerup-not-tap',
              modalState: 'open',
              sinceOpenMs: sinceOpen(),
              movePx: Math.round(moveSnapshot),
              holdMs: dt,
              ptrType: e.pointerType
            });
            lastTapEnd = null;
            return;
          }

          odxMobileZoomDbg({
            event: 'modal-tap-end',
            modalState: 'open',
            sinceOpenMs: sinceOpen(),
            x: Math.round(x),
            y: Math.round(y),
            holdMs: dt,
            ptrType: e.pointerType
          });

          if (
            lastTapEnd &&
            upAt - lastTapEnd.t <= DOUBLE_TAP_MS &&
            Math.hypot(x - lastTapEnd.x, y - lastTapEnd.y) <= DOUBLE_TAP_MAX_DIST
          ) {
            e.preventDefault();
            odxMobileZoomDbg({
              event: 'modal-close-dbltap-2nd-up',
              modalState: 'closing',
              sinceOpenMs: sinceOpen(),
              deltaMs: upAt - lastTapEnd.t,
              ptrType: e.pointerType
            });
            lastTapEnd = null;
            this.hide();
            return;
          }

          lastTapEnd = { x, y, t: upAt };
          maybeThrottleHint();
        };

        const onCancel = (e) => {
          clearLongPress();
          if (start && e.pointerId === start.id) {
            odxMobileZoomDbg({
              event: 'modal-pointercancel',
              modalState: 'open',
              sinceOpenMs: sinceOpen(),
              ptrType: e.pointerType
            });
            start = null;
            maxDist = 0;
          }
        };

        dialog.addEventListener('pointerdown', onDown, { passive: false, ...captureOpts });
        dialog.addEventListener('pointermove', onMove, { passive: true, ...captureOpts });
        dialog.addEventListener('pointerup', onUp, { passive: false, ...captureOpts });
        dialog.addEventListener('pointercancel', onCancel, { passive: true, ...captureOpts });

        this._odxTapCloseCleanup = () => {
          clearLongPress();
          const h = modal.querySelector('.odx-mobile-zoom-close-hint');
          if (h) {
            detachCloseHintAnimLoop(h);
            h.classList.remove('odx-mobile-zoom-close-hint--anim', 'odx-mobile-zoom-close-hint--reduced');
          }
          dialog.removeEventListener('pointerdown', onDown, captureOpts);
          dialog.removeEventListener('pointermove', onMove, captureOpts);
          dialog.removeEventListener('pointerup', onUp, captureOpts);
          dialog.removeEventListener('pointercancel', onCancel, captureOpts);
        };
      }

      hide() {
        odxMobileZoomDbg({
          event: 'modal-hide',
          modalState: 'closed',
          sinceOpenMs: null
        });
        const hadOdxMobileZoomLock = document.body.classList.contains('odx-mobile-zoom-lock');
        this._unbindOdxTapToClose();
        document.body.classList.remove('odx-mobile-zoom-lock');
        document.documentElement.classList.remove('odx-mobile-zoom-lock');
        this.classList.remove('product-media-modal--touch-active');
        // Double-tap close removes the overlay before the browser fires the trailing `click` / `dblclick`.
        // That click targets the gallery opener under the cursor—not the dialog—so stopPropagation on the
        // modal cannot catch it; see `suppressOpenerGhostClick` in `od-media-variant-gallery.liquid`.
        if (hadOdxMobileZoomLock) {
          window.__odxMobileZoomSuppressOpenerUntil = Date.now() + 520;
        }
        super.hide();
      }

      show(opener) {
        super.show(opener);
        const isMobile = window.matchMedia('(max-width: 749px)').matches;
        const isOdxVariantZoom = !!opener?.closest('[data-odx-mobile-zoom="variant"]');
        if (isMobile && isOdxVariantZoom) {
          document.body.classList.add('odx-mobile-zoom-lock');
          document.documentElement.classList.add('odx-mobile-zoom-lock');
          this.classList.add('product-media-modal--touch-active');
          if (typeof window.odxCloseHeaderMenuDrawer === 'function') {
            try {
              window.odxCloseHeaderMenuDrawer();
            } catch (_e) {}
          }
        } else {
          this._unbindOdxTapToClose();
        }
        this.showActiveMedia();
        if (isMobile && isOdxVariantZoom) {
          odxMobileZoomDbg({
            event: 'modal-show',
            modalState: 'open',
            sinceOpenMs: 0,
            mediaId: opener?.getAttribute?.('data-media-id') || null
          });
          this._bindOdxTapToClose();
        }
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        const activeMediaWidth = activeMedia.clientWidth || activeMedia.offsetWidth || activeMedia.width || 0;
        container.scrollLeft = Math.max(0, (activeMediaWidth - container.clientWidth) / 2);

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
